import React from 'react';
import { validateMetricName } from '@src/emp-3.0/components/Metrics/IndividualMetric/MetricDetail';
import { Input } from 'antd';
import CustomFormItem from '@src/emp-3.0/components/Metrics/IndividualMetric/MetricBuilder/CustomFormItem';
import { renderItemForViewMode } from '@src/emp-3.0/components/Metrics/IndividualMetric/MetricBuilder/index';
import useFieldRequiredStatus from '@src/pages/workflow/hooks/useFieldRequiredStatus';
import { FoldIcon } from '@src/emp-3.0/components/Metrics/components';

const MetricNameInput = ({ value, onChange, mode, form }) => {
  return mode === 'view' ? (
    renderItemForViewMode(form, 'name')
  ) : (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Input
        value={value}
        onChange={(e) => {
          onChange?.(e);
        }}
        id="name"
      />
      <FoldIcon />
    </div>
  );
};

const MetricName = ({ mode, form }) => {
  const { status, enableRequired } = useFieldRequiredStatus(['name']);

  return (
    <CustomFormItem
      name="name"
      label="Metric Name"
      validateStatus={status}
      rules={[
        {
          validator: (rule, value) => validateMetricName(rule, value, 'metric', enableRequired),
        },
      ]}
    >
      <MetricNameInput mode={mode} form={form} />
    </CustomFormItem>
  );
};

export default MetricName;
